// extracted by mini-css-extract-plugin
export default {"Container":"CreateNewTicket_Container__gm8dD","HeaderButton":"CreateNewTicket_HeaderButton__IMxVR","Multiline":"CreateNewTicket_Multiline__p+CFO"};